import React from "react";
import { useTranslation } from "react-i18next";
import { CDN_BASE_URL } from "../../../config";
import { useCart } from "../../../context/CartContext";

const ProductCard = ({ product }) => {
  const { t, i18n } = useTranslation();
  const { cartItems, addToCart, updateQuantity } = useCart();

  const cartItem = cartItems.find((item) => item.id === product.id);

  return (
    <div className="bg-white rounded-xl shadow p-3 mb-4">
      <div className="mt-2">
        <div className="flex justify-between gap-3">
          <span>
            <h3 className="text-lg font-bold text-gray-800">
              {i18n.language === "en" ? product.name_en : product.name}
            </h3>
            <p className="text-sm text-gray-600">
              {i18n.language === "en" ? product.desc_en : product.desc}
            </p>
          </span>
          <span>
            <img
              src={CDN_BASE_URL + product.img}
              alt={product.name}
              className="min-w-[90px] max-w-[90px] min-h-[90px] max-h-[90px] object-cover rounded-lg border"
            />
          </span>
        </div>

        <div className="flex justify-between items-center mt-3">
          <span className="text-green-700 font-semibold">
            {product.price.toLocaleString()} {t("rial")}
          </span>

          {/* کنترل دکمه‌ها */}
          {!cartItem ? (
            <button
              className="bg-[var(--primary)] w-[90px] text-white text-sm px-3 py-1 rounded-full hover:bg-[var(--hoverprimary)]"
              onClick={() => addToCart(product)}
            >
              {t("add")}
            </button>
          ) : (
            <div className="flex items-center gap-2 bg-gray-100 px-2 py-1 rounded-full">
              <button
                className="text-red-500 font-bold px-2"
                onClick={() => updateQuantity(product.id, -1)}
              >
                -
              </button>
              <span className="text-sm">{cartItem.quantity}</span>
              <button
                className="text-green-600 font-bold px-2"
                onClick={() => updateQuantity(product.id, 1)}
              >
                +
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
